import { render } from "./student-selector.vue?vue&type=template&id=bf3629f4"
import script from "./student-selector.vue?vue&type=script&lang=js"
export * from "./student-selector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__